import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { withLocalize, Translate } from 'react-localize-redux';
import { popupActions } from '../../store/popupStore';
import { reportActions } from '../../store/reportStore';
import { isNullOrUndefined } from '../../store/storeFunctions';
import RatingCard from './rating/ratingCard';
import { LineChart, Line, Legend, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';


import './rating/rating.scss';

class MirriRatingData extends React.Component {
    state = {
        cribisIndexEvalTooltipOpen: false,
        expanded: false,
        isExpandedTouched: false,
        tooltipDetailOpen: false
    }

    get isSkCZ() { return this.props.user.authentication.profile.agentLanguage === "sk-SK" || this.props.user.authentication.profile.agentLanguage === "cs-CZ"; }

    componentDidUpdate(prevProps) {
        if (this.props.isExpandAllActivated !== prevProps.isExpandAllActivated || this.props.isHideAllActivated !== prevProps.isHideAllActivated) {
            this.setState({ isExpandedTouched: false });
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return this.props.dataHash !== nextProps.dataHash || this.state.expanded !== nextState.expanded || this.props.isExpandAllActivated !== nextProps.isExpandAllActivated || this.props.isHideAllActivated !== nextProps.isHideAllActivated;
    }

    render() {
        return (this.props.data === undefined || this.props.data === null ? "" : <div>{this.renderWithData(this.props.data)}</div>);
    }

    renderWithData(data) {

        const styles = {
            fontFamily: "sans-serif",
            textAlign: "center",
            fontSize: "1em",
            fontWeight: "600",
            width: "100%",
            height: "400px"
        };

        return <div>

            <RatingCard cardType=""
                title={this.props.translate("Report.Ratings.ZScore")}
                tooltip={this.props.translate("Report.Ratings.ZScore.Description")}
            >
                <div style={styles}>
                        <LineChart
                            width={1150}
                            height={300} 
                            data={this.props.data.zScoreData}
                            margin={{ top: 5, right: 20, bottom: 5, left: 0 }}
                        >
                            <CartesianGrid vertical={false} stroke="#eee" />
                            <XAxis dataKey="year" type='category' />
                            <YAxis dataKey="value" label={{ value: this.props.translate("Report.Section.Mirri.ZScore"), angle: -90, fontSize: "1em", dx: "2em" }} />
                            <Tooltip />
                            <Legend />
                            <Line dataKey="value" name={this.props.translate("Report.Section.Mirri.ZScoreValue")} stroke="#8884d8" dot={{ stroke: "#8884d8", strokeWidth: 3 }} />
                        </LineChart>
                        {this.renderTable(data.zScoreData)}
                </div>
            </RatingCard>
        </div>

    }

    renderTable = (data) => {
        return    <table className="table table-report-section sticky-table" style={{marginTop: '2em'}}>
        <thead>
            <tr>
                <th style={{ width: "25%" }} >{this.props.translate("Report.FinancialStatements.ItemName")}</th>
                {data.map((val) => ( <th style={{ width: "15%" }}>{val.year}</th>))}
            </tr>
        </thead>
        <tbody>
           <tr>
            <td>{this.props.translate("Report.Section.Mirri.ZScore")}</td>
            {data.map((val) => (<td  >{ val.value}</td>))}
           </tr>
        </tbody>
    </table>
    }

    expand() {
        this.setState({
            expanded: !this.props.resolveExpanded(this.state.expanded, this.state.isExpandedTouched),
            isExpandedTouched: true
        });
    }
}

export default withRouter(withLocalize(connect(
    state => ({ report: state.report, user: state.userContext }),
    dispatch => bindActionCreators(({ ...reportActions, ...popupActions }), dispatch)
)(MirriRatingData)));

